export default __webpack_public_path__ + "static/media/2023_Januar_Schnee.69f8da2f.webp";